export enum FetchStatus {
  IDLE,
  LOADING,
  ERROR,
}
